export default __webpack_public_path__ + "static/media/portgo-screenshot-03.418ebbd8.png";